export const downloadFileByUrl = (url: string, fileName = '') => {
  const link = document.createElement('a');
  link.style.display = 'none';
  link.setAttribute('href', url);
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadFile = (obj: Blob | MediaSource, fileName = '') => {
  const url = window.URL.createObjectURL(obj);
  downloadFileByUrl(url, fileName);
  window.URL.revokeObjectURL(url);
};
